import './App.css';
import './styles/index.scss';
import { AppProvider } from "./contexts/AppContext";
import MainPage from './pages/MainPage';
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Auth from './Components/Auth';

function App() {
  return (
    <div className="w-full h-full relative dark:bg-zinc-900 dark:text-white">
      <AppProvider>
        <Auth>
          <MainPage />
        </Auth>
        <ToastContainer position="top-right" autoClose={3000} />
      </AppProvider>
    </div>
  );
}

export default App;
